module.exports = __webpack_public_path__ + "img/address_bg.63b9c7c7.png";